<template>
  <div>
    <v-toolbar class="my-md-auto" elevation="0"  >
      <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >

        <v-badge
            :color="item.state.couleur"
            overlap
            right
            inline
        >
          <h1><v-icon large>mdi-basket</v-icon>{{item['id']}} - {{ item['ref'] }}</h1>
        </v-badge>
      </v-toolbar-title>
      <v-spacer />
      <div >
                <v-btn
            v-if="userHasAccess('order_edit')"
            class="ml-sm-2"
            color="primary"
            @click="relance"
        >
          {{ $t('global.relance')}}
        </v-btn>

        <v-btn
            v-if="userHasAccess('order_edit')"
            class="ml-sm-2"
            color="primary"
            @click="editHandler(item)"
        >
          {{ $t('global.update')}}
        </v-btn>
      </div>
    </v-toolbar>
    <br />
    <v-card v-if="item" class="v" width="50%">
      <v-card-title class="text-left ">
        <span class="mr-1">{{$t('order.currentstatus')}}</span>
        <span :style="{ color:item.state.couleur  }">
          {{ item["state"].name}}
        </span>
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="item['state'].specialPrinted || item['state'].end"
          color="primary"
          @click="exportOrder(item)">
          {{ $t('order.LabelPrint')}}
        </v-btn>
        <v-btn
            v-if="userHasAccess('order_edit')"
            class="ml-sm-2"
            color="primary"
            @click="popup"
        >
          {{ $t('global.update')}}
        </v-btn>
      </v-card-actions>
    </v-card>

    <br />

    <div v-if="item" class="table-order-show">
      <v-row>
        <v-col md="4">

          <STLView
              class="ml-4"
              ref="viewSTL"
              :item="item['designFile']"
              v-if="item['designFile']"
              :edit="false"
          />
        </v-col>


        <v-col md="8">
          <h3>
            {{$t('order.request')}}
          </h3>
          <v-simple-table>
            <template slot="default">
              <thead>
              <tr>
                <th width="1">{{ $t('global.field') }}</th>
                <th width="1">{{ $t('global.value') }}</th>

                <th width="1">{{ $t('global.field') }}</th>
                <th width="1">{{ $t('global.value') }}</th>
              </tr>
              </thead>

              <tbody>
              <!-- Reference & STL-->
              <tr>
                <td><strong>{{ $t('order.ref') }}</strong></td>
                <td>
                  {{ item['ref'] }}
                </td>
                <td><strong>{{ $t('designfile.designfile') }}</strong></td>
                <td>
                  <v-btn
                      v-if="item['designFile']"
                      color="secondary"
                      class=""
                      @click="showHandlerLink(item['designFile'])"
                  >
                    <v-icon
                        v-if="item.designFile.nda"
                        left
                        color="warning"
                    >mdi-lock
                    </v-icon>
                    {{ item['designFile'].name }}
                    <v-icon
                        right
                        dark
                    >mdi-eye
                    </v-icon>
                  </v-btn>
                </td>
              </tr>
    
              <!-- Customer & type-->
              <tr>
                <td><strong>{{ $t('customer.customer') }}</strong></td>
                <td>
                  <span v-if="item['customer']">{{ item['customer'].name }}</span>
                </td>

                <td><strong>{{ $t('designfile.type') }}</strong></td>
                <td>
                  <span v-if="item['type']">{{ item['type'].name }}</span>
                </td>
              </tr>
              <!-- commercial & quantity-->
              <tr>
                <td><strong>{{ $t('order.claimant') }}</strong></td>
                <td>
                  <span>{{ item['commercial'].login }}</span>
                </td>

                <td><strong>{{ $t('order.quantity') }}</strong></td>
                <td>
                  {{ item['quantity'] }}
                </td>
              </tr>
              <!-- Tags & price-->
              <tr>
                

                <td><strong>{{ $t('order.unitPrice') }}</strong></td>
                <td>
                  {{ item['price'] }}
                </td>
                <td><strong>{{ $t('order.price') }}</strong></td>
                <td>
                  {{ item['price'] * item['quantity'] }}
                </td>
              </tr>
              <!-- Sector & Verticale-->
              <tr>
                <td><strong>{{ $t('sector.sector') }}</strong></td>
                <td>
                  <span v-if="item['sector']">{{ item['sector'].name }}</span>
                </td>

                <td><strong>{{ $t('verticale.verticale') }}</strong></td>
                <td>
                  <span v-if="item['verticale']">{{ item['verticale'].name }}</span>
                </td>
              </tr>
              <tr>
                <td><strong>{{ $t('order.tags') }}</strong></td>
                <td>
                  <div id="tags">
                    <v-chip v-for="tag in item['tags']" :key="tag.id"
                            class="ma-1 font-weight-bold"
                            color="accent"
                    >
                      {{ tag.name }}
                    </v-chip>
                  </div>
                </td>
              </tr>
              <tr>
                <td><strong>{{ $t('order.resolution') }}</strong></td>
                <td>
                  <span v-if="item['resolution']">{{ item['resolution'].name }}</span>
                </td>
                <td><strong>{{ $t('order.quotation') }}</strong></td>
                <td>
                  {{ item['quotation'] }}
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
          <br/>
          <h3>
            {{$t('order.fabrication')}}
          </h3>
          <v-simple-table>
            <template slot="default">
              <thead>
              <tr>
                <th width="1">{{ $t('global.field') }}</th>
                <th width="1">{{ $t('global.value') }}</th>

                <th width="1">{{ $t('global.field') }}</th>
                <th width="1">{{ $t('global.value') }}</th>
              </tr>
              </thead>
              <tbody>

              <!-- priority & operator-->
              <tr>
                <td ><strong>{{ $t('priority.priority') }}</strong></td>
                <td >
                  <span v-if="item['priority']">{{ item['priority'].name }}</span>
                </td>
                <td><strong>{{ $t('order.operator') }}</strong></td>
                <td>
                  <span v-if="item.operator">{{ item['operator'].login }}</span>
                </td>

              </tr>
              <!-- risk & risk Comment-->
              <tr>
                <td><strong>{{ $t('order.risk') }}</strong></td>
                <td >
                  <v-slider v-if="item.risk"
                            v-model="item.risk.value"
                            readonly
                            hide-details
                            min="0"
                            max ="200"
                            :label="item.risk.value.toString() + '%'"
                            step="25">
                  </v-slider>
                </td>

                <td><strong>{{$t('risk.comment')}}</strong></td>
                <td v-if="item.risk && item.risk.comment">
                  {{item.risk.comment}}
                </td>

              </tr>
              <!-- date delivery client & date delivery interne-->
              <tr>
                <td><strong>{{ $t('order.delivery') }}</strong></td>
                <td>
                  {{ formatDate(item['deliveryObjectif'], 'long') }}
                </td>
                <td><strong>{{ $t('order.delivery_interne') }}</strong></td>
                <td>
                  {{ formatDate(item['delivery'], 'long') }}
                </td>

              </tr>
              <!--              cost & prodfile-->
              <tr>
                <td><strong>{{ $t('order.unitCost') }}</strong></td>
                <td>
                  <span v-if="item['cost']">{{ item['cost'] }}</span>
                </td>
                <td><strong>{{ $t('order.cost') }}</strong></td>
                <td>
                  <span v-if="item['cost']">{{ item['cost'] * item['quantity'] }}</span>
                </td>
              </tr>
              <!-- material -->
              <tr>
                <td><strong>{{ $t('order.material') }}</strong></td>
                <td>
                  <span v-if="item['material']">{{ item['material'].name }}</span>
                </td>
                <td><strong>{{ $t('order.dateCloture') }}</strong></td>
                <td>
                  {{ formatDate(item['dateCloture'], 'long') }}
                </td>
              </tr>
              <tr>
                <td><strong>{{ $t('prodfile.prodfile') }}</strong></td>
                <td>
                  <v-btn
                      v-if="item['prodfile']"
                      color="secondary"
                      class=""
                      @click="showHandlerLink(item['prodfile'])"
                  >
                    <span :title="item['prodfile'].name">
  {{ truncate(item['prodfile'].name) }}
</span>

                    <v-icon
                        right
                        dark
                    >mdi-eye
                    </v-icon>
                  </v-btn>
                </td>
                <td><strong>{{ $t('order.failedItems') }}</strong></td>
                <td>
                  {{ item['failedItems'] }}
                </td>

              </tr>       
              </tbody>
            </template>
          </v-simple-table>
          <br/>
          <h3>
            {{$t('order.general')}}
          </h3>
          <v-simple-table>
            <template slot="default">
              <thead>
              <tr>
                <th width="1">{{ $t('global.field') }}</th>
                <th width="1">{{ $t('global.value') }}</th>

                <th width="1">{{ $t('global.field') }}</th>
                <th width="1">{{ $t('global.value') }}</th>
              </tr>
              </thead>
              <tbody>
              <!-- date creation & creator-->
              <tr>
                <td><strong>{{ $t('global.createdat') }}</strong></td>
                <td>
                  {{ formatDateTime(item['created'], 'long') }}              </td>
                <td><strong>{{ $t('global.createdby') }}</strong></td>
                <td>
                  <span v-if="item['createdBy']">{{ item['createdBy'].login }}</span>
                </td>

              </tr>
              <!-- date update & updatedby-->
              <tr>
                <td><strong>{{ $t('global.updatedat') }}</strong></td>
                <td>
                  {{ formatDateTime(item['updated'], 'long') }}              </td>
                <td><strong>{{ $t('global.updatedby') }}</strong></td>
                <td>
                  <span v-if="item['updatedBy']">{{ item['updatedBy'].login }}</span>
                </td>
              </tr>

              <!-- Comment-->
              <tr>
                <td colspan="1"><strong>{{ $t('order.comment') }}</strong></td>
                <td colspan="3">
                  <pre>
                  {{ item['comment']}}
                  </pre>
                </td>
              </tr>

              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
      <!--      <v-container fluid>-->
      <!--        <v-row>-->
      <!--          <v-col cols="12" sm="6" md="6">-->
      <!--            <PrinterList-->
      <!--                ref="PrinterListOrder"-->
      <!--                :designFileParent="item['designFile']"-->
      <!--            />-->
      <!--          </v-col>-->
      <!--          <v-col cols="12" sm="6" md="6">-->
      <!--            <ProdFileList-->
      <!--                ref="ProdFileListDesignFile"-->
      <!--                :designFileParent="item['designFile']"-->
      <!--            />-->
      <!--          </v-col>-->
      <!--        </v-row>-->
      <!--      </v-container>-->
            <OrderEchangeList :parent-order='item'></OrderEchangeList>
      <OrderActionList :parent-order='item'></OrderActionList>
<UpdatePopup :overlay="overlay" @close-popup="popup"></UpdatePopup>

    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import FileMixin from '../../mixins/FileMixin';
import STLView from '../../components/STLView.vue';
import UpdatePopup from '../../components/orderstate/updatePopup.vue'
import OrderActionList from "../../components/orderaction/ListSub.vue";
import OrderEchangeList from "../../components/orderaction/ListEchange.vue";
// import ProdFileList from '../prodfile/ListSub';
// import PrinterList from '../printer/ListSub';
const servicePrefix = 'Order';

export default {
  name: 'OrderShow',
  servicePrefix,
  data() {
    return {
      overlay: false,
      newOrderCreated: false,
    }
  },
  components: {
    UpdatePopup,
    Loading,
    STLView,
    OrderActionList,
    OrderEchangeList
    // ProdFileList,
    // PrinterList
  },
  mixins: [ShowMixin,AccessMixin,FileMixin],

  mounted() {
    this.orderstateGetSelectItems();
  },
  
  computed: {
    isLoading() {
      return (this.isLoading_order ||
          this.isLoading_orderstate
      );
    },

    ...mapFields('order', {
      isLoading_order: 'isLoading',
      updated: 'updated',
      created:'created',
    }),

    ...mapGetters('order', ['find']),

    ...mapFields('orderstate', {
      orderstateSelectItems: 'selectItems',
      isLoading_orderstate : 'isLoading'
    }),
  },
  methods: {
    onCreated(item) {
      if (item['name']) {
        this.showMessage(`${item['name']} ${this.$t('global.created')}`);
      } else {
        this.showMessage(`${item['@id']} ${this.$t('global.created')}`);
      }
      this.$router.push({
        name: `${this.$options.servicePrefix}Show`,
        params: { id: item['@id'] }
      });

    },
  truncate(text, maxLength = 12) {
    return text.length > maxLength
      ? text.slice(0, maxLength) + '…'
      : text;
  },


    onUploaded(item) {
      this.item.fileUploaded = true;
      this.item.file = item;
      if (item['name']) {
        this.showMessage(`${item['original_name']} ${this.$t('global.uploaded')}`);
      } else {
        this.showMessage(`${item['@id']} ${this.$t('global.uploaded')}`);
      }
    },

    relance() {

      const newOrder = { ...this.item };
      newOrder.state = "/api/order_states/23";
      this.item = { ...this.retrieved };

      delete newOrder.id;
      delete newOrder['@id'];
      delete newOrder.delivery;
      delete newOrder.deliveryObjectif;
      delete newOrder.commercial;
      delete newOrder.createdBy;
      delete newOrder.dateCloture;
      delete newOrder.operator;

      this.create(newOrder)
        .then(response => {
          const newOrderId = response.headers['location'];
          this.newOrder['@id'] = newOrderId;
          this.newOrder.id = response.data.id;

          Object.keys(this.newOrder).forEach(function(key) {
            if (this.newOrder[key] === undefined) {
              this.newOrder[key] = null;
            }
          }.bind(this));
          this.newOrderCreated = true; 
        })
        .catch(error => {
          console.error(error);
        });
    },

    ...mapActions('order', {
      update: 'update',
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load',
      create: 'create'
    }),

    ...mapActions({
      orderstateGetSelectItems: 'orderstate/fetchSelectItems'
    }),
    ...mapActions({
      processActionPrint: 'order/actionPrint',
    }),
    popup() {
      this.overlay = !this.overlay;
    },
    exportOrder(order){
      let id = order['id'];
      let route = 'exportorder/' + id;
        this.processActionPrint({
          action: route,
          name: `Order_label_${order.id}.jpg`
, 
          values: {}});
    },
  },
  watch: {
    created(created) {
      if (!created) {
        return;
      }
      if (this.inputfile) {
        this.uploadFileCreateItem(created['id'],created['@entity'],this.inputfile,'file');
      }
      this.onCreated(created);
    },
    newOrderCreated(newOrderCreated) {
      if (!newOrderCreated) {
        return;
      }
      this.onCreated(this.newOrder);
      this.newOrderCreated = false;
    },
  }
};
</script>
<style>
pre {
  font-family: "Roboto", sans-serif;
  tab-size: 4;
  line-height: 1.5;
}

td {
  max-width: 200px;
  align: middle;
}
</style>
